/**
 * Modulo 'uikit-util' richiesto dai componenti dist di UIkit (alias in webpack.mix.js):
 * sono le utility dello stesso UIkit core incluso in vendor.js
 */
module.exports = require('uikit/dist/js/uikit-core').util;
